// sidebarItem.js
// import sidebarItem from '@/layouts/vertical-sidebar/sidebarItem.js';
import sidebarItem from '@/layouts/full/vertical-sidebar/sidebarItem';
import { store, key } from '@/storeVuex';
import { isFullAdmin } from '@/utils/fullAdmin';
import { hasPermission, permissionMap } from '@/utils/permissions';
export default class Roles {
    private user?: any;
    private pages?: any;
    private newpage?: any;

    // NOTE: FOR ADMIN TO ALLOW ALL ROLES ADD THIS VALUE TO DATABASE USERS TABLE ROLES -> {"admin":"admin"}
    constructor(store, router) {
        this.user = store.state.user ? store.state.user.user : null;
        this.pages = router.options.routes[1].children;

        this.newpage = sidebarItem;
    }

    listRoles() {
        return [
            { text: 'View', value: '0' },
            { text: 'Add', value: '1' },
            { text: 'Edit', value: '2' },
            { text: 'Delete', value: '3' }
        ];
    }

    listPages() {
        const pages = [];

        // return this.newpage;

        this.newpage.forEach((element) => {
            if (element.header) {
                if (element.ispage == true) {
                    pages.push({
                        header: element.header,
                        value: element.proj_manage,
                        page: []
                    });
                }
            }
            pages.forEach((list) => {
                if (element.title) {
                    if (element.isPage == true) {
                        if (element.proj_manage == list.value) {
                            list.page.push({
                                text: element.title,
                                value: element.to
                            });
                        }
                    }
                }
            });
        });

        return pages;

        // this.newpage.forEach(element => {
        //     if(element.header)return null;
        //     if(element.children){
        //         element.children.forEach(child_element => {

        //             pages.push({
        //                 'value': child_element.to,
        //                 'text': element.title + ' > ' + child_element.title,
        //             });
        //         });
        //     }else{
        //         pages.push({
        //             'value': element.to,
        //             'text': element.title,
        //         });
        //     }
        // });

        // return pages;
    }

    byPassPage(pagename) {
        let bol = false;
        const arr = ['/login', '/two-factor-auth'];

        if (arr.indexOf(pagename) > -1) {
            bol = true;
        }
        return bol;
    }

    // restrictPlayerPages(pagename){
    //     let bol = true;
    //     if( this.user.state.currentUser.isplayer ){
    //         if( this.allowed_player_pages.indexOf(pagename) > -1 ){
    //             bol = true;
    //         }else{
    //             bol = false;
    //         }
    //     }
    //     return bol;
    // }

    /**
     * Can the current user perform `section` on `pagename`?
     *
     * Backs `v-if="$role.restricAccess($route.name, 'delete')"` in the page
     * templates. The method had an EMPTY body, so it returned undefined —
     * falsy — and every button guarded by it was permanently hidden regardless
     * of role (the To Dos page's Add and Delete buttons among them).
     *
     * @param pagename the route name, which is also the permission slug
     * @param section  'view' | 'add' | 'edit' | 'delete' (case-insensitive)
     */
    restricAccess(pagename, section) {
        if (!pagename || !section) return false;

        // Same bypass the nav and the router guard use.
        if (isFullAdmin(this.user)) return true;
        if (this.user?.id == 1) return true;

        const actions = { view: 'View', add: 'Add', edit: 'Edit', delete: 'Delete' };
        const action = actions[String(section).toLowerCase()];
        if (!action) return false;

        return hasPermission(this.user, pagename, action);
    }

    restricMenu(pagename) {
        if (this.user) {
            if (this.user.id == 1) return true;
        }

        const roles = permissionMap(this.user);

        // BYPASS MENU IF isPage VALUE IS FALSE
        if (this.isPageCheck(pagename) == false) {
            return true;
        }

        if (roles != null) {
            let bol = false;
            Object.keys(roles).forEach((key) => {
                const temp = key.split('__');
                const status = roles[key];
                // A malformed key with no "__" (the documented {"admin":"admin"}
                // hack at the top of this file is one) would throw on temp[1].
                if (temp.length < 2) return;
                if (pagename == temp[0] && temp[1].toUpperCase() == 'VIEW' && status == true) {
                    bol = status;
                }
            });
            return bol;
        }
    }

    restrictDropdownMenu(pages) {
        if (this.user) {
            if (this.user.id == 1) return true;
        }

        const roles = permissionMap(this.user);

        if (roles != null) {
            let bol = false;
            pages.forEach((pagename) => {
                Object.keys(roles).forEach((key) => {
                    const temp = key.split('__');
                    const status = roles[key];
                    if (temp.length < 2) return;
                    if (pagename == temp[0] && temp[1].toUpperCase() == 'VIEW' && status == true) {
                        bol = status;
                    }
                });
            });
            return bol;
        }
    }

    isPageCheck(pagename) {
        let isPage = false;

        Object.keys(this.pages).forEach((key) => {
            if (this.pages[key].name == pagename) {
                if (this.pages[key].isPage) {
                    isPage = true;
                }
            }
        });

        return isPage;
    }
}
